// Auto-generated file

import { type ComponentType, lazy } from "react";

type ScreenModule = { default: ComponentType };

const SCREEN_LOADERS: Record<string, () => Promise<ScreenModule>> = {
  "email-verification-result": () =>
    import("@/screens/email-verification-result"),
  login: () => import("@/screens/login"),
  "login-id": () => import("@/screens/login-id"),
  "login-password": () => import("@/screens/login-password"),
  "login-passwordless-email-code": () =>
    import("@/screens/login-passwordless-email-code"),
  "reset-password": () => import("@/screens/reset-password"),
  "reset-password-email": () => import("@/screens/reset-password-email"),
  "reset-password-error": () => import("@/screens/reset-password-error"),
  "reset-password-request": () => import("@/screens/reset-password-request"),
  "reset-password-success": () => import("@/screens/reset-password-success"),
  signup: () => import("@/screens/signup"),
};

const resolvedScreens: Record<string, ComponentType> = {};
const lazyScreens: Record<string, ComponentType> = {};

/**
 * Resolves a screen's module before the first render, so it renders directly
 * instead of behind a Suspense fallback, which React reveals ~300 ms late
 * (CX-902). In production the screen's chunk is already a <script> in the
 * page head, so this does not wait on the network.
 */
export const preloadScreen = async (
  screenName: string | null | undefined
): Promise<void> => {
  const loader = screenName ? SCREEN_LOADERS[screenName] : undefined;
  if (!screenName || !loader) {
    return;
  }
  resolvedScreens[screenName] = (await loader()).default;
};

export const getScreenComponent = (
  screenName: string | undefined
): ComponentType | null => {
  if (!screenName) {
    return null;
  }
  if (resolvedScreens[screenName]) {
    return resolvedScreens[screenName];
  }
  const loader = SCREEN_LOADERS[screenName];
  if (!loader) {
    return null;
  }
  lazyScreens[screenName] ??= lazy(loader);
  return lazyScreens[screenName];
};
